import ReactGA from "react-ga4";

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

let analyticsInitialized = false;

/**
 * Dynamically load Google Analytics gtag.js script
 * Only called after user consent
 */
const loadGtagScript = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    // Check if script already loaded
    if (document.querySelector('script[src*="googletagmanager.com/gtag"]')) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-LZ4KHYDSBZ';
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load gtag.js'));
    document.head.appendChild(script);
  });
};

/**
 * Initialize Google Analytics only after user consent
 * This function dynamically loads the script and initializes tracking
 */
export const initializeAnalytics = async (): Promise<void> => {
  // Prevent double initialization
  if (analyticsInitialized) {
    return;
  }

  try {
    // Load gtag.js script
    await loadGtagScript();

    // Initialize gtag config
    if (window.gtag) {
      window.gtag('js', new Date());
      window.gtag('config', 'G-LZ4KHYDSBZ', {
        cookie_flags: 'SameSite=None;Secure',
        anonymize_ip: true,
      });
    }

    // Initialize ReactGA
    ReactGA.initialize("G-LZ4KHYDSBZ", {
      gaOptions: {
        cookieFlags: "SameSite=None;Secure",
        anonymizeIp: true,
      },
    });

    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
    });

    analyticsInitialized = true;
  } catch (err) {
    // Silently fail - analytics is non-critical
  }
};
